import React from 'react';
import { LogoWithText } from '../Logos';
import { withWebAssetsTheme } from '../../theme';
import useStyles from './useErrorPageStyles';

export type HttpErrorPageProps = {
  children?: React.ReactNode;
};

export function HttpErrorPage({
  children,
}: HttpErrorPageProps): React.ReactElement {
  const { pageContainer, pageLogoLink } = useStyles();
  const logoLinkId = 'HttpErrorPage_Logo_Link';
  return (
    <div className={pageContainer}>
      <a href="/" data-testid={logoLinkId} className={pageLogoLink}>
        <LogoWithText />
      </a>
      {children}
    </div>
  );
}

export const withHttpErrorPage = <T extends object>(
  Component: React.ComponentType<T>,
  pageProps?: Omit<HttpErrorPageProps, 'children'>
) => (props: T) => {
  return (
    <HttpErrorPage {...pageProps}>
      <Component {...props} />
    </HttpErrorPage>
  );
};

export default withWebAssetsTheme(HttpErrorPage);
